import { useForceUpdate } from "@cayo/shared/hooks/useForceUpdate";
import useHover from "./mouse-hover.hook";
import { useTeachingBubbles } from "./teachingBubblesHook";
import useInterval from "./timer.hook";
import usePreventRequestDuplication from "./use-prevent-qequest-duplication.hook";
import { useUserSettings } from "./userSettingsHook";
import { useWindowResize } from "./useWindowResize";

const globalHooks = {
  useUserSettings,
  useTeachingBubbles,
  useHover,
  usePreventRequestDuplication,
  useInterval,
  useForceUpdate,
  useWindowResize,
};

export default globalHooks;
